export type AcademicEnrollmentType = 'high_school' | 'post_secondary' | 'none';

export type AcademicEnrollmentTypeCode =
  | 'high-school'
  | 'trade-technical'
  | 'community-college'
  | 'college-university'
  | 'graduate-school'
  | 'non-student'
  | 'post-secondary';

export const ENROLLMENT_TYPES = {
  HIGH_SCHOOL: 'High School',
  TRADE_TECHNICAL_SCHOOL: 'Trade/Technical School',
  COMMUNITY_COLLEGE: 'Community College',
  COLLEGE_UNIVERSITY: 'College/University',
  GRADUATE_SCHOOL: 'Graduate School',
  NOT_CURRENTLY_A_STUDENT: 'I am not currently a student',
} as const;
